import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { debounce } from 'lodash'

import { usersSelector } from '@/state/user/slices/index.slices'
import { useUsersActions } from './use-users-actions.hook'

export const useUsersFilters = () => {
  const { getAllUsers, setUserFilters } = useUsersActions()

  const { filters, pagination } = useSelector(usersSelector)

  // eslint-disable-next-line
  const filterDelay = useCallback(
    debounce((newFilters: any) => {
      getAllUsers(newFilters)
    }, 500),
    [],
  )

  const handleChangeSearch = (
    field: string,
    value: string,
    debounce?: boolean,
  ) => {
    const newFilters = {
      ...filters,
      [field]: value,
      page: 1,
    }

    setUserFilters(newFilters)

    if (debounce) {
      filterDelay(newFilters)
    } else {
      getAllUsers(newFilters)
    }
  }

  const handleChangePage = (newPage: number) => {
    setUserFilters({ ...filters, page: newPage })
    getAllUsers({ ...filters, page: newPage })
  }

  const handleChangeLimit = (newLimit: number) => {
    if (newLimit > pagination.total) {
      setUserFilters({ ...filters, limit: newLimit, page: 1 })
      getAllUsers({ ...filters, limit: newLimit })
    } else {
      setUserFilters({ ...filters, limit: newLimit })
      getAllUsers({ ...filters, limit: newLimit })
    }
  }

  return {
    filters,
    handleChangeSearch,
    handleChangePage,
    handleChangeLimit,
  }
}
